import { TableCell } from '@mui/material';
import { HeaderCell, SHORTCUTS_HEADER_CELLS } from 'modules/shortcuts/models';
import React from 'react';

export const ShortcutsTableListHeader: React.FC<{}> = ({

}) => {
    const isFirstColumn = (hc: HeaderCell): boolean => hc.id === SHORTCUTS_HEADER_CELLS[0].id;

    const createColumnHeader = (hc: HeaderCell) : JSX.Element => 
        <TableCell
            key={hc.id}
            align={isFirstColumn(hc) ? "left" : "center"}
            padding={isFirstColumn(hc) ? "none" : "normal"}
        >
            {hc.label}
        </TableCell>;

    return <React.Fragment>
        {
            SHORTCUTS_HEADER_CELLS.map((hc: HeaderCell) => createColumnHeader(hc))
        }
    </React.Fragment>;
};